import meta from '../meta';


const dataUtils = require('../../../viscomjs/utils/data');
const TouctSupport = require('../../../viscomjs/utils/TouctSupport');
const ShareButtons = require('../../../viscomjs/ui/ShareButtons');


const params = {
    class: 'share',
    triggerClass: 'share__trigger',
    buttonClass: 'share__button'
}

ShareButtons(meta, '.' + params.buttonClass);

const start = shareObject => {
    if (!shareObject.hasTriggers) return;
    shareObject.triggers.forEach(startTrigger);
};

const startTrigger = tgr => {
    tgr.setAvailableAction('byHoverAndClick');
    tgr.addEventListener('click', tgr.toggle);
};


const stop = shareObject => {
    if (!shareObject.hasTriggers) return;
    shareObject.triggers.forEach(stopTrigger);
};

const stopTrigger = tgr => {
    const el = tgr.data.root;
    tgr.removeEventListener('click', tgr.toggle);
    el.removeEventListener('click', tgr.doHover);
    el.removeEventListener('click', tgr.doOut);
    el.removeEventListener('click', tgr.doOut);
};


const reset = shareObject => {
    if (!shareObject.hasTriggers) return;
    shareObject.triggers.forEach(resetTrigger);
};

const resetTrigger = tgr => {
    const el = tgr.data.root;
    shareObject.setOffState(el);
    tgr.setAvailableAction('byHoverAndClick');
};

const toggle = (evt, tgr, shareObject) => {
    const el = tgr.data.root;
    const onState = getOnState(el);
    if (onState === 'on') {
        shareObject.setOffState(el);
        tgr.setAvailableAction('byHoverAndClick');
    } else {
        shareObject.setOnState(el);
        tgr.setAvailableAction('byClick');
    }
    // tgr.setAvailableAction(onState !== 'off' ? 'byHoverAndClick' : 'byClick');
};

const doHover = function (evt, tgr, shareObject) {
    shareObject.setOnStateByHover(tgr.data.root);
}

const doOut = function (evt, tgr, shareObject) {
    shareObject.setOffState(tgr.data.root);
}

const setOnState = (el, root, shareObject, isHover) => {
    if (isHover && root.dataset.shareFixed === 'true') return;

    const curShareKey = el.dataset.shareKey;
    shareObject.triggers.filter(tgr => tgr.dataset.shareKey !== curShareKey).forEach(resetTrigger);

    el.classList.add('active');
    el.dataset.on = isHover ? 'onByHover' : 'on';

    root.dataset.share = 'true';
    if (isHover)
        delete root.dataset.shareFixed;
    else
        root.dataset.shareFixed = 'true';
    root.dataset.curShareKey = curShareKey;
};

const setOffState = (el, root) => {
    const curShareKey = el.dataset.shareKey;
    el.classList.remove('active');
    el.dataset.on = 'off';

    if (curShareKey === root.dataset.curShareKey) {
        delete root.dataset.shareFixed;
        delete root.dataset.share;
        delete root.dataset.curShareKey;
    }
};

const setAvailableAction = (tgr, el, type) => {
    // Only click support for touchable devices:
    if (TouctSupport.support.touch) return;

    switch (type) {
        case 'byHoverAndClick':
            el.addEventListener('mouseover', tgr.doHover);
            el.addEventListener('mouseout', tgr.doOut);
            el.addEventListener('mouseleave', tgr.doOut);
            break;
        case 'byClick':
            el.removeEventListener('mouseover', tgr.doHover);
            el.removeEventListener('mouseout', tgr.doOut);
            el.removeEventListener('mouseleave', tgr.doOut);
            break;
    }
    el.dataset.type = type;
};

const getOnState = el => {
    return el.dataset.on;
};

const getAvailableAction = el => {
    return el.dataset.type;
};




const share = [...document.querySelectorAll('.' + params.class)];
const shareObject = {};
const body = document.body;

shareObject.start = function () {
    start(this);
}.bind(shareObject);

shareObject.stop = function () {
    stop(this);
}.bind(shareObject);

shareObject.reset = function () {
    reset(this);
}.bind(shareObject);

shareObject.toggle = function (evt, tgr) {
    toggle(evt, tgr, this);
}.bind(shareObject);

shareObject.doHover = function (evt, tgr) {
    doHover(evt, tgr, this);
}.bind(shareObject);

shareObject.doOut = function (evt, tgr) {
    doOut(evt, tgr, this);
}.bind(shareObject);

shareObject.setOnState = function (el) {
    setOnState(el, body, this);
}.bind(shareObject);

shareObject.setOnStateByHover = function (el) {
    setOnState(el, body, this, true);
}.bind(shareObject);

shareObject.setOffState = function (el) {
    setOffState(el, body, this);
}.bind(shareObject);



share.forEach((el, index) => {
    el.dataset.shareKey = 'share-' + index;
    // Set initial state
    shareObject.setOffState(el);
});


shareObject.triggers = share.map((el, index) => {
    const tgr = el.querySelector('.' + params.triggerClass);
    dataUtils.setData(tgr, 'root', el);
    tgr.dataset.shareKey = 'share-' + index;

    tgr.toggle = function (evt) {
        shareObject.toggle(evt, this);
    }.bind(tgr);

    tgr.doHover = function (evt) {
        shareObject.doHover(evt, this);
    }.bind(tgr);

    tgr.doOut = function (evt) {
        shareObject.doOut(evt, this);
    }.bind(tgr);

    tgr.setAvailableAction = type => {
        setAvailableAction(tgr, tgr.data.root, type);
    };
    tgr.getAvailableAction = () => {
        return getAvailableAction(tgr.data.root);
    };
    return tgr;
});
shareObject.hasTriggers = shareObject.triggers.length > 0;


shareObject.start();


// WEBPACK FOOTER //
// ./js/viscom/boss/soccers/components/shareListWithTrigger.js